import { render, staticRenderFns } from "./DefaultLayoutForPremium.vue?vue&type=template&id=a9f7d436&"
import script from "./DefaultLayoutForPremium.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutForPremium.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports